/**
 * Cookie Consent Types
 *
 * Types for GDPR-compliant cookie consent management
 */

export type CookieCategory = 'necessary' | 'functional' | 'analytics' | 'marketing';

export interface CookieConsentPreferences {
  necessary: boolean; // Always true, cannot be disabled
  functional: boolean;
  analytics: boolean;
  marketing: boolean;
  consentGiven: boolean;
  consentTimestamp: string | null;
  consentVersion: string;
}

export interface CookieInfo {
  name: string;
  provider: string;
  purpose: string;
  expiry: string;
  type: 'cookie' | 'localStorage' | 'sessionStorage';
}

export interface CookieCategoryInfo {
  id: CookieCategory;
  name: string;
  description: string;
  required: boolean;
  cookies: CookieInfo[];
}

/**
 * Consent state for the store
 */
export interface ConsentState {
  preferences: CookieConsentPreferences;
  isBannerOpen: boolean;
  isSettingsOpen: boolean;
  consentVersion: string;
}

/**
 * Consent actions for the store
 */
export interface ConsentActions {
  acceptAll: () => void;
  rejectAll: () => void;
  savePreferences: (prefs: Partial<CookieConsentPreferences>) => void;
  openSettings: () => void;
  closeSettings: () => void;
  resetConsent: () => void;
}

/**
 * Combined consent store type
 */
export type ConsentStore = ConsentState & ConsentActions;

/**
 * Consent storage key for localStorage
 */
export const CONSENT_STORAGE_KEY = 'shell-consent-preferences';

/**
 * Current version of the consent policy
 * Update this when policy changes to force re-consent
 */
export const CURRENT_CONSENT_VERSION = '1.0.0';
